import { z } from 'zod';

export type CarApproveFormErrors = {
    documents?: string[],
    photos?: string[],
    videos?: string[],
};

export const CarApproveFormErrorsSchema = z.object({
    documents: z.array(z.string()).optional(),
    photos: z.array(z.string()).optional(),
    videos: z.array(z.string()).optional(),
});
